import { postRequest } from '@/utils/request';
import { getHost } from '@/utils/utils';

export async function ejectDisk(data) {
  const host = await getHost('device');
  return postRequest(`${host}/v1/device/umountall`, data);
}

export async function relieveDevice(data) {
  const host = await getHost('device');
  return postRequest(`${host}/v1/user/unbindonecloud`, data, { selfCase: true });
}
